export default "__VITE_ASSET__yhyxAD1U__"